/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsIcon } from '@squiz/sds';
import clsx from 'clsx';
import React from 'react';
import { DxpScreenBannerProps } from './DxpScreenBanner.props';

/**
 * DXP Console Screen Banner.
 */
export const DxpScreenBanner = (props: DxpScreenBannerProps): JSX.Element => {
  const { classes, description, icon, title, ...rest }: DxpScreenBannerProps = props;

  const bannerClass = clsx(`screen-banner`, classes);

  return (
    <div className={bannerClass} {...rest}>
      <SdsIcon svg={icon} />
      <div className="screen-banner__content">
        <h2 className="screen-banner__title">{title}</h2>
        <div className="screen-banner__description">{description}</div>
      </div>
    </div>
  );
};
